export default {
  data() {
    return {
      val: [],
    };
  },
  props: {
    /**
     * The field name.
     */
    name: {
      type: String,
      required: true,
    },

    /**
     * The field type.
     */
    type: {
      type: String,
      required: false,
    },

    /**
     * The field value.
     */
    value: {
      required: false,
      default: [],
    },

    /**
     * The options for the select field. Should be a array of objects with id and name attributes.
     */
    options: {
      type: Array,
      required: false,
      default: () => [],
    },

    /**
     * The base key to translate the form.
     */
    translation: {
      type: String,
      required: false,
    },

    /**
     * If the input has label.
     */
    hasLabel: {
      type: Boolean,
      required: false,
    },

    /**
     * If the input has error.
     */
    error: {
      type: String,
      required: false,
    },

    /**
     * If the input has error.
     */
    insideForm: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    /**
     * This method will be called when input event is fired.
     *
     * @param  {String} name    The field name.
     */
    onInput(name) {
      return (value) => {
        this.$emit("change", name, value);
      };
    },
  },

  /**
   * This function will be called to render the HTML.
   *
   * @param  {Function} h    Mandatory for vue to render JSX.
   */
  /* eslint no-console: ["error", { allow: ["log", "error"] }] */
  // eslint-disable-next-line
  render(h) {
    let value = this.value;
    if (typeof this.value === "string" && this.value === "") {
      value = [];
    }
    const options = Object.keys(this.options).map((k) => (
      <el-checkbox
        value={this.options[k].id.toString()}
        label={this.options[k].name.toString()}
      ></el-checkbox>
    ));

    const checkboxGroup = (
      <el-checkbox-group
        value={value}
        loading={this.loading}
        disabled={this.disabled}
        onInput={this.onInput(this.name)}
      >
        {options}
      </el-checkbox-group>
    );

    if (!this.insideForm) {
      return checkboxGroup;
    }

    let label = null;
    if (this.hasLabel) {
      label = this.translation
        ? this.$t(`${this.translation}.label`)
        : this.name;
    }

    return (
      <el-form-item error={this.error} label={label}>
        {checkboxGroup}
      </el-form-item>
    );
  },
};



// WEBPACK FOOTER //
// ./src/app/components/form/checkboxGroup/checkboxGroup.jsx